import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Gift, Sparkles } from "lucide-react";
import { api } from "../lib/api";

// Live "recent loot drops" ticker for the home page. Hidden until real drops exist.
const LootTicker = () => {
  const [drops, setDrops] = useState([]);

  useEffect(() => {
    const load = () => api.get("/loot/recent", { params: { limit: 20 } }).then((r) => {
      const next = r.data || [];
      setDrops((prev) => (prev[0]?.id === next[0]?.id && prev.length === next.length ? prev : next));
    }).catch(() => {});
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, []);

  if (!drops.length) return null;
  const loop = [...drops, ...drops];

  return (
    <div data-testid="home-loot-ticker" className="relative overflow-hidden glass border border-[#2A2E3D] tactical-frame-sm ticker-wrap">
      <div className="relative flex items-center h-9">
        <div className="shrink-0 h-full flex items-center gap-1.5 px-3 bg-[#D4A94A]/15 border-r border-[#D4A94A]/30 z-10">
          <Gift className="w-3.5 h-3.5 text-[#D4A94A]" />
          <span className="font-stencil font-black uppercase text-[10px] tracking-widest text-[#D4A94A]">Loot Drops</span>
        </div>
        <div className="flex-1 overflow-hidden ticker-mask">
          <div className="ticker-track flex items-center whitespace-nowrap w-max">
            {loop.map((d, i) => (
              <span key={`${d.id}-${i}`} className="flex items-center">
                <span className="inline-flex items-center gap-2 px-4 shrink-0 font-mono text-xs" data-testid="loot-ticker-item">
                  <Sparkles className="w-3.5 h-3.5 shrink-0" style={{ color: d.color || "#D4A94A" }} />
                  <Link to={d.user_id ? `/u/${d.user_id}` : "/loot"} className="font-black uppercase tracking-wide text-[#F5D77A] hover:underline">{d.callsign}</Link>
                  <span className="text-[#94A3B8]">{d.type === "xp" ? "banked" : "scored"}</span>
                  <span className="font-bold uppercase" style={{ color: d.color || "#D4A94A" }}>{d.type === "xp" ? d.name : `${d.rarity} ${d.name}`}</span>
                </span>
                <span className="text-[#2A2E3D] shrink-0">/</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LootTicker;
